import React, { useMemo } from 'react';
import { Pagination as BsPagination, Form } from 'react-bootstrap';

const ACTIVE_STYLE = { backgroundColor: '#0A0A17', borderColor: '#0A0A17' };

const DROPDOWN_STYLE = {
  width: 'auto',
  minWidth: '125px',
  height: '36px',
  fontSize: '0.8rem',
  borderRadius: '50px',
  border: '1px solid #dee2e6',
  backgroundColor: '#fff',
  cursor: 'pointer',
  paddingLeft: '14px',
  paddingRight: '30px',
  appearance: 'none',
  backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 10px center',
  backgroundSize: '14px 10px'
};

const getPageNumbers = (currentPage, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages = [1];

  const start = Math.max(2, currentPage - 1);
  const end = Math.min(totalPages - 1, currentPage + 1);

  if (start > 2) pages.push('...');

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (end < totalPages - 1) pages.push('...');

  pages.push(totalPages);

  return pages;
};

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = useMemo(
    () => getPageNumbers(currentPage, totalPages),
    [currentPage, totalPages]
  );

  return (
    <div className="d-flex justify-content-center align-items-center my-4 gap-3">
      <style>{`
        .pagination-rounded-arrows .page-item:first-child .page-link {
          border-top-left-radius: 100px;
          border-bottom-left-radius: 100px;
        }
        .pagination-rounded-arrows .page-item:last-child .page-link {
          border-top-right-radius: 100px;
          border-bottom-right-radius: 100px;
        }
      `}</style>
      <BsPagination className="mb-0 pagination-rounded-arrows">
        <BsPagination.Prev
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />

        {pageNumbers.map((page, index) =>
          page === '...' ? (
            <BsPagination.Ellipsis key={`ellipsis-${index}`} disabled />
          ) : (
            <BsPagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => onPageChange(page)}
              style={page === currentPage ? ACTIVE_STYLE : undefined}
            >
              {page}
            </BsPagination.Item>
          )
        )}

        <BsPagination.Next
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
      </BsPagination>

      {totalPages > 5 && (
        <Form.Select
          size="sm"
          value={currentPage}
          onChange={(e) => onPageChange(parseInt(e.target.value, 10))}
          style={DROPDOWN_STYLE}
          className="shadow-sm"
        >
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <option key={p} value={p}>
              Pagina {p} di {totalPages}
            </option>
          ))}
        </Form.Select>
      )}
    </div>
  );
};

export default Pagination;
